import type { INavigationModalActions } from "./NavigationModal";

import * as css from "./NavigationSuccessPage.module.css";

export interface INavigationSuccessPage extends INavigationModalActions {
    title: string;
    firstDescription?: string;
    secondDescription?: string;
}

export const NavigationSuccessPage = (props: INavigationSuccessPage) => (
    <div className={css.navigationSuccessPageComponent}>
        <div className={css.innerContent}>
            <h1 className={css.standardTitle}>{props.title}</h1>
            {props.firstDescription && (
                <p className={css.description} dangerouslySetInnerHTML={{ __html: props.firstDescription }} />
            )}
            {props.secondDescription && (
                <p
                    className={css.description}
                    dangerouslySetInnerHTML={{ __html: props.secondDescription }}
                />
            )}
        </div>
    </div>
);
